import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { setIsAllViewActive } from "../../../redux/commonSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
var CustomTabList = styled(TabList)({
// borderRadius: "none",
});
var CustomTab = styled(Tab)({
    textTransform: "capitalize"
});
export var DashboardTabComponent = function (props) {
    var trackButtonClick = useAnalyticsEventTracker("DashboardTabComponent");
    var _a = props.bgColorApply, bgColorApply = _a === void 0 ? false : _a, variant = props.variant, _b = props.showTabIndicator, showTabIndicator = _b === void 0 ? false : _b, sx = props.sx, _c = props.tabVariant, tabVariant = _c === void 0 ? "scrollable" : _c;
    var _d = React.useState("My view"), value = _d[0], setValue = _d[1];
    var dashboardList = [{
            id: "1",
            DisplayName: "My view",
            Name: "My view"
        }, {
            id: "2",
            DisplayName: "All view",
            Name: "All view"
        }];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    React.useEffect(function () {
        if (isAllViewActive) {
            setValue('All view');
        }
    }, []);
    var dispatch = useAppDispatch();
    var handleChange = function (event, newValue) {
        trackButtonClick("ButtonClickEvent", "".concat(newValue), undefined);
        setValue(newValue);
        dispatch(setIsAllViewActive(!isAllViewActive));
    };
    return /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: sx
    }, /*#__PURE__*/ React.createElement(CustomTabList
    // sx={{
    //     "& .MuiTabs-indicator": {
    //         display: showTabIndicator ? "block" : "none"
    //     },
    // }}
    , {
        variant: tabVariant,
        onChange: handleChange
    }, dashboardList === null || dashboardList === void 0 ? void 0 : dashboardList.map(function (item, index) { /*#__PURE__*/ return React.createElement(CustomTab, {
        key: index,
        label: item === null || item === void 0 ? void 0 : item.DisplayName,
        value: item === null || item === void 0 ? void 0 : item.Name,
        sx: {
            fontSize: 'lg'
        }
    }); }))));
};
